module.exports = __webpack_public_path__ + "be197b36f63e116b9c908627a40dd274.svg";